export function scrolledIntoView(element, threshold = 0) { /* eslint-disable-line import/prefer-default-export */
  const docViewTop = window.pageYOffset || document.documentElement.scrollTop;
  const docViewBottom = docViewTop + window.innerHeight;
  const elementTop = element.offsetTop;
  const elementBottom = elementTop + (element.offsetHeight - threshold);
  return elementBottom <= docViewBottom;
}
